import React from "react";
import { Link } from "react-router-dom";
import "./training.css";

const programs = [
  {
    title: "CPL & ATPL Ground Classes",
    img: "CPL&ATPL.svg",
    link: "https://rightsourceaviation.com/dgca-classes/",
  },
  {
    title: "Airline Preparation",
    img: "airline.svg",
    link: "https://rightsourceaviation.com/#DGCA-exam",
  },
  {
    title: "Flight Training",
    img: "flight.svg",
    redirect: "flightTraining",
    
  },
  {
    title: "Type Rating",
    img: "Type-Rating.svg",
    redirect: "type-rating",
  },
  {
    title: "Cadet Pilot Program",
    img: "cadet-pilot.svg",
    link: "https://rightsourceaviation.com/cadet-pilot-program/",
  },
  {
    title: "On Demand Lectures",
    img: "on-demand.svg",
    link: "https://rightsourceaviation.com/dgca-classes/",
  },
];

const scrollToSection = (id) => {

  const section = document.getElementById(id);

  if (section) {
    section.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }

};
const TrainingPrograms = () => {
  return (
    <section className="training-clean-section">
      <div className="container">

        {/* Heading */}
        <div className="text-center mb-5">
          <h2 className="training-clean-title">Our Training Programs</h2>
          <p className="training-clean-subtitle">
            Comprehensive training programs designed to transform aspiring pilots into certified professionals
          </p>
        </div>

        {/* Cards */}
        <div className="row g-4">
          {programs.map((item, index) => (
            <div className="col-6 col-md-4 col-lg-4 mb-4" key={index}>
              <div className="training-card-clean">

                <div className="training-icon-box">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/img/${item.img}`}
                    alt={item.title}
                  />
                </div>

                <h5 className="training-card-title">
                  {item.title}
                </h5>
<Link
  to={item.link ? item.link : "#"}
  onClick={(e) => {
    if (!item.link) {
      e.preventDefault();
      scrollToSection(item.redirect);
    }
  }}
  className="training-link"
>
  Learn More <span>→</span>
</Link>

              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TrainingPrograms;
